import { useClickOutside } from "@hooks/useClickOutside.js";
import { useRef, useState } from "react";

const Dropdown = ({ value, options, onChange, disabled = false, className = "" }) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	// Close dropdown when clicking outside
	useClickOutside(dropdownRef, () => setIsOpen(false));

	const handleToggle = () => {
		if (!disabled) {
			setIsOpen(!isOpen);
		}
	};

	const handleSelect = (optionValue) => {
		if (!disabled) {
			onChange(optionValue);
			setIsOpen(false);
		}
	};

	// Get the display label for the selected value
	const selectedLabel = options[value] || value;

	return (
		<div ref={dropdownRef} className={`relative ${className}`}>
			<button
				onClick={handleToggle}
				disabled={disabled}
				className={`inline-flex min-h-[40px] items-center justify-center gap-2 whitespace-nowrap rounded-lg px-3 font-medium text-light-white text-xs transition-all duration-200 focus:outline-none focus:ring-4 sm:min-h-[44px] sm:px-4 sm:text-sm md:px-5 md:text-base ${
					disabled
						? "cursor-not-allowed bg-gray-600 opacity-50"
						: "bg-blue-gray hover:bg-dark-blue focus:ring-dark-blue"
				}`}
				type="button"
				aria-haspopup="true"
				aria-expanded={isOpen}
			>
				{selectedLabel}
				<svg
					className={`h-3 w-3 shrink-0 text-white sm:h-4 sm:w-4 md:h-4 md:w-4`}
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 10 6"
				>
					<path
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="2"
						d="m1 1 4 4 4-4"
					/>
				</svg>
			</button>

			{isOpen && !disabled && (
				<div className="absolute left-0 z-10 mt-2 w-36 divide-y divide-gray-100 rounded-lg bg-dark-blue shadow-lg">
					<ul className="py-2 text-light-white text-sm" role="menu">
						{Object.entries(options).map(([key, label]) => (
							<li key={key} role="none">
								<button
									onClick={() => handleSelect(key)}
									className={`block w-full px-4 py-2 text-left transition-colors duration-150 hover:bg-blue-gray hover:text-white ${
										value === key ? "bg-blue-gray/50 font-semibold" : ""
									}`}
									role="menuitem"
								>
									{label}
								</button>
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default Dropdown;
